export default {
  nav: {
    home: 'الرئيسية',
    video: 'المراقبة بالفيديو',
    alarm: 'أنظمة الإنذار',
    solutions: 'الحلول',
    care: 'SSG Care',
    planner: 'مخطط الكاميرات',
    areas: 'مناطق الخدمة',
    about: 'من نحن',
    contact: 'اتصل بنا',
  },
  dropdown: {
    allSolutions: 'عرض جميع الحلول',
    homeGrounds: 'المنزل والملكية',
    retailGastro: 'التجزئة والمطاعم',
    officePractice: 'المكتب والعيادة',
    warehouseLogistics: 'المستودعات واللوجستيات',
    workshopTrade: 'الورش والمهن',
    apartments: 'المباني السكنية والعقارات',
    cameraTypes: 'أنواع الكاميرات',
    services: 'الخدمات',
    technology: 'التقنية',
  },
  footer: {
    brandLine: 'تقنية الأمان للأفراد والشركات',
    area: 'هاينبورغ · منطقة الراين-ماين',
    services: 'الخدمات',
    solutions: 'الحلول',
    forWhom: 'لمن',
    contact: 'اتصل بنا',
    areaLabel: 'منطقة الخدمة الراين-ماين',
    privateCustomers: 'العملاء الأفراد',
    businessCustomers: 'عملاء الأعمال',
    allSolutions: 'جميع الحلول',
    faq: 'الأسئلة الشائعة',
    rights: 'جميع الحقوق محفوظة.',
    impressum: 'بيانات الناشر',
    privacy: 'سياسة الخصوصية',
    cookieSettings: 'إعدادات ملفات تعريف الارتباط',
  },
  related: {
    eyebrow: 'حلول أخرى',
    title: 'اكتشف أنواعًا أخرى من المباني',
    viewAll: 'عرض جميع الحلول',
  },
};